import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { CustomCellRendererProps } from 'ag-grid-react';
import { Tooltip } from '@wk/components-v3-react16';
import { ServerDashboardJob } from '../../dashboardType';
import styles from './OrchestrationNameCell.module.scss';

const OrchestrationNameCell = (
  properties: CustomCellRendererProps<ServerDashboardJob>
) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const cellReference = useRef<HTMLDivElement>(null);

  const product = properties.data?.product?.name || '';
  const workflow = properties.data?.workflow?.name || '';
  const displayValue = [workflow, product].filter(Boolean).join('/');
  const cellId = `orchestration-name-${properties.data?.jobId}`;

  useLayoutEffect(() => {
    const checkTruncation = () => {
      if (cellReference.current) {
        const isCellTruncated =
          cellReference.current.scrollWidth > cellReference.current.clientWidth;
        setIsTruncated(isCellTruncated);
      }
    };

    checkTruncation();
    const timeoutId = setTimeout(checkTruncation, 100);

    return () => clearTimeout(timeoutId);
  }, [displayValue]);

  useEffect(() => {
    if (!cellReference.current) {
      return undefined;
    }

    const resizeObserver = new ResizeObserver(() => {
      if (cellReference.current) {
        const isCellTruncated =
          cellReference.current.scrollWidth > cellReference.current.clientWidth;
        setIsTruncated(isCellTruncated);
      }
    });

    resizeObserver.observe(cellReference.current);

    return () => resizeObserver.disconnect();
  }, []);

  if (!displayValue) {
    return null;
  }

  return (
    <>
      <div className={styles.cellWrapper}>
        <div
          id={cellId}
          ref={cellReference}
          className={styles.cellText}
          onMouseEnter={() => setIsTooltipOpen(true)}
          onMouseLeave={() => setIsTooltipOpen(false)}
        >
          {workflow}
          {product && (
            <span
              style={{
                color: '#98a6ad',
                fontStyle: 'italic',
              }}
            >
              /{product}
            </span>
          )}
        </div>
      </div>
      {isTruncated &&
        createPortal(
          <Tooltip
            targetSelector={`#${cellId}`}
            isOpen={isTooltipOpen}
            position="top"
          >
            {displayValue}
          </Tooltip>,
          document.querySelector('#root') as HTMLElement
        )}
    </>
  );
};

export default OrchestrationNameCell;
